<template>
  <div v-show="value" class="pl-2 text-left text-xxs text-red-700 sm:text-xs">
    {{ value }}
  </div>
</template>

<script setup lang="ts">
defineProps({
  value: {
    type: String,
  },
});
</script>
